import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ShowFormulaContext } from '../contexts';

// เลขกำกับเล็กๆ หน้าป้าย label — เหมือน pattern "26 หมายเหตุ" ของหัวคอลัมน์ตาราง P5
export function RowNum({ num }) {
  const showFormula = useContext(ShowFormulaContext);
  if (!showFormula) return null;
  if (num == null) return null;
  return (
    <Box
      component="span"
      sx={{ fontSize: '0.68rem', color: 'text.disabled', mr: 0.4 }}
    >
      {num}
    </Box>
  );
}

// สูตรประกอบ — โชว์เฉพาะตอนเปิดสวิตช์ "แสดงสูตร" (ShowFormulaContext)
// inline=true: ต่อท้าย label ในบรรทัดเดียวกัน (ล้นแล้วตัดบรรทัดได้)
// inline=false: แสดงเป็นบรรทัดแยกใต้แถว
export function FormulaLine({ formula, inline = false }) {
  const showFormula = useContext(ShowFormulaContext);
  if (!showFormula || !formula) return null;
  return (
    <Typography
      variant="caption"
      component="span"
      sx={{
        display: inline ? 'inline' : 'block',
        fontSize: '0.65rem',
        color: '#7c3aed',
        fontStyle: 'italic',
        ml: inline ? 0.5 : 0,
        pl: inline ? 0 : 0.5,
        pb: inline ? 0 : 0.2,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
      }}
    >
      {formula}
    </Typography>
  );
}
